// extracted by mini-css-extract-plugin
export default {"header-container":"Header_header-container__pSpb+","main-container":"Header_main-container__zECXt"};